module.exports = __webpack_public_path__ + "img/11.3.TP.e583b1b4.png";